import { map } from 'rxjs'
import { fromFetch } from 'rxjs/fetch'

/** CSV values stay strings: dates, account numbers and leading zeroes are source content. */
export function parseCsv(text: string): string[][] {
	text = text.replace(/^\uFEFF/, '')
	if (!text) return []
	const counts = new Map([
		[',', 0],
		[';', 0],
		['\t', 0],
	])
	let quoted = false
	for (let i = 0; i < text.length; i++) {
		if (text[i] === '"') {
			if (quoted && text[i + 1] === '"') i++
			else quoted = !quoted
		} else if (!quoted) {
			if (text[i] === '\r' || text[i] === '\n') break
			if (counts.has(text[i])) counts.set(text[i], counts.get(text[i])! + 1)
		}
	}
	const delimiter = [...counts].sort((a, b) => b[1] - a[1])[0][0]
	const rows: string[][] = []
	let row: string[] = []
	let cell = ''
	quoted = false
	let closed = false
	for (let i = 0; i < text.length; i++) {
		const char = text[i]
		if (quoted) {
			if (char === '"') {
				if (text[i + 1] === '"') {
					cell += '"'
					i++
				} else {
					quoted = false
					closed = true
				}
			} else cell += char
		} else if (char === delimiter || char === '\r' || char === '\n') {
			row.push(cell)
			cell = ''
			closed = false
			if (char !== delimiter) {
				rows.push(row)
				row = []
				if (char === '\r' && text[i + 1] === '\n') i++
			}
		} else if (char === '"' && cell === '' && !closed) quoted = true
		else {
			if (closed || char === '"') throw new Error('Invalid CSV quoting')
			cell += char
		}
	}
	if (quoted) throw new Error('Unclosed CSV quote')
	if (cell !== '' || row.length || closed) {
		row.push(cell)
		rows.push(row)
	}
	return rows
}

/** Both table and thumbnail cancel their requests when replaced or disconnected. */
export function csvRows(src: string) {
	return fromFetch(src, {
		selector: response => {
			if (!response.ok) throw new Error('CSV request failed')
			return response.text()
		},
	}).pipe(map(parseCsv))
}
